import React, { useState, useEffect  } from 'react';
import { useNavigate } from 'react-router-dom';
import PersonalInfo from '../components/Profile/PersonalInfo';
import '../styles/Profile.css';
import { Helmet } from 'react-helmet';
import { ConfigProvider, Tabs, message, Spin, Button  } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import EducationInfo from '../components/Profile/EducationInfo';
import EmploymentInfo from '../components/Profile/EmploymentInfo';
import RelativesInfo from '../components/Profile/RelativesInfo';
import AdditionalInfo from '../components/Profile/AdditionalInfo';
import NavBar from '../components/Profile/NavBar';
import { API_URL, API_username, API_password } from '../utils/api';

const Profile = () => {
	const [loading, setLoading] = useState(true);
	const navigate = useNavigate();
	useEffect(() => {
		getDropdownLists();		
	}, []);

	const [hashAmount, setHashAmount] = useState([]);

	const [nationalities, setNationalities] = useState([]);
	const [citizenshipCountries, setCitizenshipCountries] = useState([]);
	const [birthPlaceCountries, setBirthPlaceCountries] = useState([]);
	const [relBirthPlaceCountries, setRelBirthPlaceCountries] = useState([]);
	const [employmentCountries, setEmploymentCountries] = useState([]);
	const [registrationAddressCountries, setRegistrationAddressCountries] = useState([]);
	const [residentialAddressCountries, setResidentialAddressCountries] = useState([]);
	const [maritalStatuses, setMaritalStatuses] = useState([]);
	const [languages, setLanguages] = useState([]);
	const [languageDegrees, setLanguageDegrees] = useState([]);
	const [docTypesEducation, setDocTypesEducation] = useState([]);
	const [educationTypes, setEducationTypes] = useState([]);
	const [educationKinds, setEducationKinds] = useState([]);
	const [employmentTypes, setEmploymentTypes] = useState([]);
	const [softwares, setSoftwares] = useState([]);
	const [softwareLevels, setSoftwareLevels] = useState([]);
	const [genders, setGenders] = useState([]);
	const [institutions, setInstitutions] = useState([]);
	const [relationshipDegrees, setRelationshipDegrees] = useState([]);
	const [documentTypes, setDocumentTypes] = useState([]);
	const [specialties, setSpecialties] = useState([]);

	const [changedData, setChangedData] = useState({});

	const [formData, setFormData] = useState({
		Name: '',
		AnalogName: '',
		AllowedEdit: true,
		BirthDate: '',
		BirthPlace: {
			SpecialBirthPlace: 0,
			City: "",
			District: "",
			Region: "",
			Country: {
				Name: "",
				UID: ""
			}
		},
		Nationality: {
			Name: "",
			UID: ""
		},
		Citizenship: {
			Name: "",
			UID: ""
		},
		Passport: {
			type: {
				Name: "",
				UID: ""
			},
			DocSeries: '',
			DocNumber: '',
			DocIssued: '',
			DocDateIssued: '',
			departmentCode: '',
			DocValid: '',
			DocInfoValid: ''			
		},
		MaritalStatus: {
			Name: "",
			UID: ""
		},
		EmailWork: '',
		EmailPersonal: '',
		INN: '',
		INPS: '',
		Sex: {
			Name: "",
			UID: ""
		},
		Photo: null,
		MobilePhoneWork: {
			countryCode: '',
			areaCode: '',
			number: '',
			extNumber: '',
			value: '',
			comment: ''
		},
		HomePhoneNumber: {
			countryCode: '',
			areaCode: '',
			number: '',
			extNumber: '',
			value: '',
			comment: ''
		},
		MobilePhonePersonal: {
			countryCode: '',
			areaCode: '',
			number: '',
			extNumber: '',
			value: '',
			comment: ''
		},
		WorkPhoneNumber: {
			countryCode: '',
			areaCode: '',
			number: '',
			extNumber: '',
			value: '',
			comment: ''
		},
	});

	const [educationData, setEducationData] = useState([
		{
			Start: '',
			End: '',
			EducationType: {
				Name: '',
				UID: ''
			},
			EducationKind: {
				Name: '',
				UID: ''
			},
			Institution: {
				Name: '',
				UID: ''
			},
			Faculty: '',
			Speciality: {
				Name: '',
				UID: ''
			},
			DocTypeEducation: {
				Name: '',
				UID: ''
			},
			DocSeries: '',
			DocNumber: '',
			DocDateIssued: '',
			RowKey: ''
		}
	]);

	const [languageData, setLanguageData] = useState([
		{
			Language: {
				Name: '',
				UID: ''
			},
			LanguageDegree: {
				Name: '',
				UID: ''
			},
			RowKey: ''
		}
	]);

	const [computerSkillsData, setComputerSkillsData] = useState([
		{
			Software: {
				Name: '',
				UID: ''
			},
			SoftwareLevel: {
				Name: '',
				UID: ''
			},
			RowKey: ''
		}
	]);

	const [employmentData, setEmploymentData] = useState([
		{
			EmploymentDate: '',
			DismissalDate: '',
			Organization: '',
			Departament: '',
			Position: '',
			Address: '',
			Duties: '',
			ActivityProfile: '',
			Country: {
				Name: '',
				UID: ''
			},
			City: '',
			EmploymentType: {
				Name: '',
				UID: ''
			},
			RowKey: '',
			InGroupActivity: false
		}
	]);

	const [relativesData, setRelativesData] = useState([
		{
			RelationshipDegree: {
				Name: '',
				UID: ''
			},
			Name: '',
			BirthDate: '',
			BirthPlace_Country: {
				Name: '',
				UID: ''
			},
			Position: '',
			ResidencePlace: '',
			WorkPlace: '',
			Dependent: '',
			IsDisabled: '',
			RowKey: ''
		}
	]);

	const [RegistrationAddress, setRegistrationAddress] = useState({
		AddressType: "",
		Country: {
			Name: "",
			UID: ""
		},
		City: {
			Subject: "",
			Area: "",
			MunicipalDistrict: "",
			City: "",
			Village: "",
			IntracityDistrict: "",
			PopulationPoint: "",
			Territory: "",
		},
		Street: "",
		HouseType: "",
		TypeBuilding: "",
		TypePremises: "",
		House: "",
		Building: "",
		Premises: "",
		Index: "",
		ViewAddresses: ""
	});

	const [ResidenceAddress, setResidentialAddress] = useState({
		AddressType: "",
		Country: {
			Name: "",
			UID: ""
		},
		City: {
			Subject: "",
			Area: "",
			MunicipalDistrict: "",
			City: "",
			Village: "",
			IntracityDistrict: "",
			PopulationPoint: "",
			Territory: "",
		},
		Street: "",
		HouseType: "",
		TypeBuilding: "",
		TypePremises: "",
		House: "",
		Building: "",
		Premises: "",
		Index: "",
		ViewAddresses: ""
	});
	const [ShiftMode, setShiftWorkReady] = useState(true);
	const [Prosecution, setLegalIssues] = useState(true);
	const selectors = {
		nationalities: nationalities, 
		citizenshipCountries: citizenshipCountries,
		birthPlaceCountries: birthPlaceCountries, 
		relBirthPlaceCountries: relBirthPlaceCountries, 
		employmentCountries: employmentCountries,
		maritalStatuses: maritalStatuses,
		languageDegrees: languageDegrees,
		languages: languages,
		docTypesEducation: docTypesEducation,
		educationTypes: educationTypes,
		educationKinds: educationKinds,
		employmentTypes: employmentTypes,
		softwares: softwares,
		softwareLevels: softwareLevels,
		genders: genders,
		institutions: institutions,
		relationshipDegrees: relationshipDegrees,
		documentTypes: documentTypes,
		specialties: specialties,
		registrationAddressCountries: registrationAddressCountries,
		residentialAddressCountries: residentialAddressCountries
	}

	const handleCancelButtonClick = () => {
		setLoading(true);
		let apiUrl = `${API_URL}/lk?method=deletingapplications&inbody=0`;
		let sessionId = localStorage.getItem("SessionId")
		fetch(apiUrl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Basic ' + btoa(`${API_username}:${API_password}`),
				'sessionid': sessionId
			},
			body: JSON.stringify({UID : ''})
		})
		.then(response => {
			if (response.status === 200) {
				return response.json();
			} else if (response.status === 202) {
				message.error('Сервер на данный момент перегружен!');
				return "error";
			} else if (response.status === 404) {
				message.error('Сессия не найдена, попробуйте еще раз!');
				return "error";
			} else {
				message.error('Произошла ошибка при отправке запроса!');
				return "error";
			}
		}).then(data => {
			if(data !== "error") {
				if(data.DeletingApplications.length === 0) {
					message.error('Запрос уже обработан ответственным HR сотрудником, отмена невозможна!');
					navigate('/applications');
				} else {
					const deleteAllowed = data.DeletingApplications[0].deletion;
					if(deleteAllowed) {
						message.success('Запрос успешно отменен');
						navigate('/applications');
					} else {
						message.error('Запрос уже обрабатывается ответственным HR сотрудником, отмена невозможна!');
						setLoading(false);
					}
				}
			}
		});		
	};

	const hasNewEducationRowAdded = () => {
		let hasNewEducationRow = false;
		if (changedData.hasOwnProperty('Education')) {
			const educationData = changedData['Education'];
			for (const educationItem of educationData) {
				if (educationItem.Deletable === true && educationItem.delete !== true) {
					hasNewEducationRow = true;
				}
			}
		} 
		return hasNewEducationRow;
	}

	const handleSaveButtonClick = () => {
		// console.log(changedData)
		const hasNewEducationRow = hasNewEducationRowAdded();
		const isFileAttached = changedData.hasOwnProperty('AttachedFiles');
		
		if(hasNewEducationRow && !isFileAttached) {
			message.info('Были добавлены новые данные об образовании, необходимо загрузить файл, удостоверяющее образование!');
		} else {
			setLoading(true);
			let apiUrl = `${API_URL}/lk?method=changeinfo&inbody=1`;
			let sessionId = localStorage.getItem("SessionId")
			fetch(apiUrl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Basic ' + btoa(`${API_username}:${API_password}`),
					'sessionid': sessionId,
					'hashamount': hashAmount
				},
				body: JSON.stringify(changedData)
			})
			.then(response => {
				if (response.status === 200) {
					message.success('Запрос успешно отправлен');
					navigate('/applications');
					return "success";
				} else if (response.status === 202) {
					message.error('Сервер на данный момент перегружен!');
					return "error";
				} else if (response.status === 404) {
					message.error('Сессия не найдена, попробуйте еще раз!');
					navigate('/logout');
					return "error";
				} else {
					message.error('Произошла ошибка при отправке запроса!');
					return "error";
				}
			});
		}
	};

	const getinfo = () => {
		let apiUrl = `${API_URL}/lk?method=getinfo&inbody=0`;
		let sessionId = localStorage.getItem("SessionId")
		fetch(apiUrl, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Basic ' + btoa(`${API_username}:${API_password}`),
				'sessionid': sessionId
			}
		})
		.then(response => {
			if (response.status === 200) {
				setHashAmount(response.headers.get('Hashamount'));
				return response.json();
			} else if (response.status === 202) {
				message.error('Сервер на данный момент перегружен!');
				return "error";
			} else if (response.status === 404) {
				message.error('Сессия не найдена, попробуйте еще раз!');
				navigate('/logout');
				return "error";
			} else {
				message.error('Произошла ошибка при отправке запроса!');
				return "error";
			}
		})
		.then(data => {
			if (data === "error") {

			} else {
				setFormData(prevState => {
					const updatedFormData = { ...prevState };
					processFormData(data, updatedFormData);
					return updatedFormData;
				});
				setEducationData(processFormData(data.Education, data.Education));
				setLanguageData(data.Languages);
				setComputerSkillsData(data.ComputerSkills);
				setEmploymentData(processFormData(data.LaborActivity, data.LaborActivity));
				setRelativesData(processFormData(data.Family, data.Family));
				if(data.RegistrationAddress.length !== 0) {
					setRegistrationAddress(data.RegistrationAddress);
				}
				if(data.ResidenceAddress.length !== 0) {
					setResidentialAddress(data.ResidenceAddress);
				}
				setShiftWorkReady(data.ShiftMode);
				setLegalIssues(data.Prosecution);
				const shortInfo = JSON.parse(localStorage.getItem('shortinfo'));
				shortInfo.Photo = data.Photo;
				localStorage.setItem('shortinfo', JSON.stringify(shortInfo));
			}
		})
		.catch(error => {
			message.error('Ошибка: ' + error.message);
		}).finally(() => {
			setLoading(false);
		});
	};
	
	const getDropdownLists = () => {
		let apiUrl = `${API_URL}/lk?method=getdropdownlists&inbody=0`;
		let sessionId = localStorage.getItem("SessionId")
		fetch(apiUrl, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Basic ' + btoa(`${API_username}:${API_password}`),
				'sessionid': sessionId
			}
		})
		.then(response => {
			if (response.status === 200) {
				return response.json();
			} else if (response.status === 202) {
				message.error('Сервер на данный момент перегружен!');
				return "error";
			} else if (response.status === 404) {
				message.error('Сессия не найдена, попробуйте еще раз!');
				navigate('/logout');
				return "error";
			} else {
				message.error('Произошла ошибка при отправке запроса!');
				return "error";
			}
		})
		.then(data => {
			if (data === "error") {

			} else {
				let nationalitiesJSON = data.Nationalities.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Nationality",
						uid: item.UID
					}
				}));
				let citizenshipCountriesJSON = data.Countries.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Citizenship",
						uid: item.UID
					}
				}));
				let birthPlaceCountriesJSON = data.Countries.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Country",
						grandparent: "BirthPlace",
						uid: item.UID
					}
				}));
				let registrationAddressCountriesJSON = data.Countries.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Country",
						uid: item.UID
					}
				}));
				let residentialAddressCountriesJSON = data.Countries.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Country",
						uid: item.UID
					}
				}));
				let relBirthPlaceCountriesJSON = data.Countries.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "BirthPlace_Country",
						uid: item.UID
					}
				}));
				let employmentCountriesJSON = data.Countries.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Country",
						uid: item.UID
					}
				}));
				let maritalStatusesJSON = data.FamilyStatus.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "MaritalStatus",
						uid: item.UID
					}
				}));
				let languageDegreesJSON = data.LanguageDegrees.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "LanguageDegree",
						uid: item.UID
					}
				}));
				let languagesJSON = data.Languages.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Language",
						uid: item.UID
					}
				}));
				let docTypesEducationJSON = data.DocTypesEducation.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "DocTypeEducation",
						uid: item.UID
					}
				}));
				let educationTypesJSON = data.EducationTypes.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "EducationType",
						uid: item.UID
					}
				}));
				let educationKindsJSON = data.EducationKinds.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "EducationKind",
						uid: item.UID
					}
				}));
				let employmentTypesJSON = data.EmploymentTypes.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "EmploymentType",
						uid: item.UID
					}
				}));
				let softwaresJSON = data.Softwares.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Software",
						uid: item.UID
					}
				}));
				let softwareLevelsJSON = data.SoftwareLevels.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "SoftwareLevel",
						uid: item.UID
					}
				}));
				const map = new Map();
				data.Institutions.forEach(obj => {
					if (map.has(obj.Name)) {
						const existingObj = map.get(obj.Name);
						existingObj.UID = obj.UID;
					} else {
						map.set(obj.Name, obj);
					}
				});
				const uniqueObjects = Array.from(map.values());
				let institutionsJSON = uniqueObjects.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Institution",
						uid: item.UID
					}
				}));
				let gendersJSON = data.Genders.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Sex",
						uid: item.UID
					}
				}));
				let relationshipDegreesJSON = data.RelationshipDegrees.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "RelationshipDegree",
						uid: item.UID
					}
				}));
				let documentTypesJSON = data.DocumentsTypes.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "type",
						grandparent: "Passport",
						uid: item.UID
					}
				}));
				let specialtiesJSON = data.Specialties.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Speciality",
						uid: item.UID
					}
				}));
				setNationalities(nationalitiesJSON);
				setCitizenshipCountries(citizenshipCountriesJSON);
				setBirthPlaceCountries(birthPlaceCountriesJSON);
				setRelBirthPlaceCountries(relBirthPlaceCountriesJSON);
				setEmploymentCountries(employmentCountriesJSON);
				setMaritalStatuses(maritalStatusesJSON);
				setLanguages(languagesJSON);
				setLanguageDegrees(languageDegreesJSON);
				setDocTypesEducation(docTypesEducationJSON);
				setEducationTypes(educationTypesJSON);
				setEducationKinds(educationKindsJSON);
				setEmploymentTypes(employmentTypesJSON);
				setSoftwares(softwaresJSON);
				setSoftwareLevels(softwareLevelsJSON);
				setGenders(gendersJSON);
				setInstitutions(institutionsJSON);
				setRelationshipDegrees(relationshipDegreesJSON);
				setDocumentTypes(documentTypesJSON);
				setSpecialties(specialtiesJSON);
				setRegistrationAddressCountries(registrationAddressCountriesJSON);
				setResidentialAddressCountries(residentialAddressCountriesJSON);
				getinfo();
			}
		})
		.catch(error => {
			message.error('Ошибка: ' + error.message);
		});
	};

	const processFormData = (data, formData) => {
		for (const key in data) {
			if (formData.hasOwnProperty(key)) {
				// Если значение является объектом, вызываем processFormData рекурсивно
				if (typeof data[key] === 'object' && data[key] !== null) {
					formData[key] = processFormData(data[key], formData[key] || {});
				} else {
					formData[key] = data[key];
				}
			}
		}
		return formData;
	};

	return (
		<ConfigProvider
			theme={{
				components: {
					Select: {
						optionFontSize: '12px'
					}
				},
			}}
		>	
			<Helmet>
				<title>Изменение персональных данных - Личный Кабинет Enter Engineering</title>
			</Helmet>
			<div className='dashboard'>
				<NavBar />
				<div className='dashboard-content' style={{ padding: '0' }}>
					{loading && (<div className='loader-container'>
						<Spin size="large"/>
					</div>)}
					<div className='profile-controls-panel'>
						{formData.AllowedEdit === true ? <Button loading={loading} style={{ margin: '15px 15px 0 0', borderRadius: '15px', zIndex: '999999' }} onClick={handleSaveButtonClick} icon={<SendOutlined />} type={'primary'} disabled={formData.AllowedEdit ? false : true}>Отправить изменения на согласование</Button>	: (<Button disabled={loading} danger style={{ borderRadius: '15px', zIndex: '999999' }} onClick={handleCancelButtonClick}>Отменить изменения</Button>	)}
					</div>
					<Tabs
						defaultActiveKey="1"
						type="card"
						size="small"
						items={[
							{
								label: 'Персональные данные',
								key: 'personal',
								children: <PersonalInfo 
									formData={formData} 
									setFormData={setFormData}
									registrationAddress={RegistrationAddress}
									residentialAddress={ResidenceAddress}
									setRegistrationAddress={setRegistrationAddress}
									setResidentialAddress={setResidentialAddress} 
									selectors={selectors} 
									changedData={changedData}
									setChangedData={setChangedData}
									handleCancelButtonClick={handleCancelButtonClick}
									handleSaveButtonClick={handleSaveButtonClick}
									loading={loading} />,
							},
							{
								label: 'Образование',
								key: 'education',
								children: <EducationInfo
									educationData={educationData}
									languageData={languageData}
									computerSkillsData={computerSkillsData}
									setEducationData={setEducationData}
									setLanguageData={setLanguageData}
									setComputerSkillsData={setComputerSkillsData}
									selectors={selectors}
									changedData={changedData}
									setChangedData={setChangedData}
									allowedEdit={formData.AllowedEdit} />,
							},
							{
								label: 'Трудовая деятельность',
								key: 'labour',
								children: <EmploymentInfo
									employmentData={employmentData}
									setEmploymentData={setEmploymentData}
									selectors={selectors}
									setChangedData={setChangedData}
									allowedEdit={formData.AllowedEdit} />,
							},
							{
								label: 'Сведения о близких родственниках',
								key: 'relations',
								children: <RelativesInfo
									relativesData={relativesData}
									setRelativesData={setRelativesData}
									selectors={selectors}
									setChangedData={setChangedData}
									allowedEdit={formData.AllowedEdit} />,
							},
							// {
							// 	label: 'Дополнительные сведения',
							// 	key: 'additional',
							// 	children: <AdditionalInfo 
							// 	shiftWorkReady={ShiftMode} 
							// 	setShiftWorkReady={setShiftWorkReady} 
							// 	legalIssues={Prosecution} 
							// 	setLegalIssues={setLegalIssues}
							// 	setChangedData={setChangedData}
							// 	allowedEdit={formData.AllowedEdit} />,
							// },
						]}
					/>
				</div>
			</div>
		</ConfigProvider>
	);
};

export default Profile;
